export default {"src":"/_next/static/media/heart.762f3eb7.svg","height":512,"width":512};